module.exports = __webpack_public_path__ + "img/key.f083ceab.svg";